import { IVfAppMarketApp } from './vf-market-app.interface';
import { IBundleUpdate } from './IBundleUpdate.interface';

export interface IBundle {
  acquirerBundleIsDefault: boolean;
  acquirerBundleStatus: string;
  acquirerEntityUid: string;
  appmarketBundleId: string;
  assignedAppmarketAppIds: string[];
  assignedAppmarketApps: IVfAppMarketApp[];
  bundleAppConList: IBundleAppConList[];
  bundleDesc: string;
  bundleIcon: string;
  bundleId: string;
  bundleName: string;
  bundleVersionId: string;
  bundleVersionName: string;
  createdBy: string;
  isFeatured: boolean;
  isPilot: boolean;
  isPublic: boolean;
  isDefault: boolean;
  hasAssignments: boolean;
  merchantEntityUids?: string[];
  oneTimePrice: number;
  recurringPrice: number;
  status: string;
  timeCreated: Date;
  timeUpdated: Date;
  updatedBy: Date;
  versionsToUpdate: IBundleUpdate[];
  hasInstallsIndicator?: boolean;
  modelFamilies: string[];
  modelFamiliesWithDeviceModels?: {
    [modelFamilyValue: string]: string[];
  };
}

export interface IBundleAppConList {
  appBundleDiscountAmount: number;
  appBundleDiscountPercent: number;
  appBundlePrice: number;
  appmarketAppId: string;
  bundleId: string;
  id: string;
}
